<template>
  <div v-if="plan_override_exists" class="w-100 h-100 d-flex justify-content-center align-items-center pr-3">
    <a href="/user/revert-plan-type-override"
       class="btn btn-ss">
      <i class="la la-close" />Revert Plan Type
    </a>
  </div>
</template>

<script>
import PlanTypesMixin from 'VueMixins/PlanTypesMixin';

export default {
  mixins: [PlanTypesMixin],
  computed: {
    plan_override_exists() {
      return this.plan_type_data?.override != null;
    },
  },
};
</script>
